export default __webpack_public_path__ + "static/media/ExampleDoorHanger.ccefc1c1.png";